import { render } from "./FotterComponent.vue?vue&type=template&id=3fc960b0"
import script from "./FotterComponent.vue?vue&type=script&lang=js"
export * from "./FotterComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SebastiánContreras\\OneDrive - Defensoría del Contribuyente\\Documents\\INGENIERIA DESARROLLO_TI\\REPOSITORIO_PROYECTOS\\AUTENTIFICACION_FRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__